module.exports = __webpack_public_path__ + "static/media/studentPic.16e07768.svg";